import { getPaginatedVideos } from "./paginationAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    videos: [],
    isActive: false,
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchPaginatedVideos = createAsyncThunk(
    "pagination/fetchPaginatedVideos",
    async ({ tags, search, author, index }) => {
        const videos = await getPaginatedVideos(tags, search, author, index);
        return videos;
    }
);

const paginationSlice = createSlice({
    name: "videos",
    initialState,
    reducers: {
        activeStatus: (state, action) => {
            state.isActive = true;
        },
        deactiveStatus: (state, action) => {
            state.isActive = false;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedVideos.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchPaginatedVideos.fulfilled, (state, action) => {
                state.isLoading = false;
                state.videos = action.payload;
            })
            .addCase(fetchPaginatedVideos.rejected, (state, action) => {
                state.isLoading = false;
                state.videos = [];
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default paginationSlice.reducer;
export const { activeStatus, deactiveStatus} = paginationSlice.actions;
